// src/components/filters/ParameterInputSelectable.tsx

import React from "react";
import { BaseParameterFilterInputProps } from "./BaseParameterFilterInputProps";
import { ParameterDataType, SelectionType } from "../../types/Category";
import MultiSelectDropdown from "./MultiSelectDropdown";

export interface ParameterFilterInputPropsSelectable
    extends BaseParameterFilterInputProps {
    dataType: ParameterDataType.SELECTABLE;
    selectionType: SelectionType;
    value: string; // SINGLE: selected option ("" = none). MULTI: CSV string.
    options: string[];
}

const ParameterInputSelectable: React.FC<ParameterFilterInputPropsSelectable> = ({
                                                                                     name,
                                                                                     value,
                                                                                     options,
                                                                                     selectionType,
                                                                                     onChange,
                                                                                 }) => {
    // -----------------------------
    // MULTI => dropdown with checkboxes (CSV value)
    // -----------------------------
    if (selectionType === SelectionType.MULTI) {
        const values = value ? value.split(",").map((s) => s.trim()).filter(Boolean) : [];

        return (
            <MultiSelectDropdown
                options={options}
                values={values}
                onChange={(next) => onChange(name, next.join(","))}
            />
        );
    }

    // -----------------------------
    // SINGLE => radio buttons
    // -----------------------------
    return (
        <div style={{ display: "flex", flexDirection: "column", gap: "0.3rem" }}>
            <label style={{ display: "flex", alignItems: "center", gap: "0.4rem" }}>
                <input
                    type="radio"
                    checked={value === ""}
                    onChange={() => onChange(name, "")}
                />
                None
            </label>

            {options.map((opt) => (
                <label key={opt} style={{ display: "flex", alignItems: "center", gap: "0.4rem" }}>
                    <input
                        type="radio"
                        checked={value === opt}
                        onChange={() => onChange(name, opt)}
                    />
                    {opt}
                </label>
            ))}
        </div>
    );
};

export default ParameterInputSelectable;